import { translate } from "../../translations/translate";

const translateField = (key) => translate(`store.${key}`);

export const fields = [
  {
    name: translateField("name"),
    key: "name",
    type: "text",
    disabled: true,
  },
  {
    name: translateField("address"),
    key: "address",
    type: "text",
    disabled: true,
  },
  {
    name: translateField("dimensions"),
    key: "storeDimensions",
    type: "number",
    disabled: true,
  },
  {
    name: translateField("capacity"),
    key: "capacity",
    type: "number",
    disabled: false,
  },
  {
    name: translateField("longitude"),
    key: "longitude",
    type: "text",
    disabled: true,
  },
  {
    name: translateField("latitude"),
    key: "latitude",
    type: "text",
    disabled: true,
  },
  {
    name: translateField("description"),
    key: "description",
    type: "text",
    disabled: false,
  },
  {
    name: translateField("phone"),
    key: "phoneNumber",
    type: "text",
    disabled: true,
  },
  {
    name: "Activated Booking",
    key: "bookingActivated",
    type: "checkbox",
    disabled: false,
  },
  {
    name: translateField("averageWaitTime"),
    key: "averageWaitTime",
    type: "number",
    disabled: false,
    transform: (time: number | string) => Math.floor(Number(time) / 60000),
  },
];
